<template>
  <v-content>
    <v-container fluid>
      <OLoadingDialog :value="isLoading" />
      <DetailsDialog ref="detailsDialog" />

      <v-card>
        <v-toolbar flat class="card-bar">
          <v-toolbar-title>Redis Browser</v-toolbar-title>
          <v-btn icon @click="reload">
            <v-icon>refresh</v-icon>
          </v-btn>

          <v-spacer />

          <v-select
            v-model="selectedDb"
            hide-details
            label="Redis Database"
            :items="allDbs"
            item-value="value"
            item-text="label"
          />

          <v-spacer />
        </v-toolbar>

        <OPaginatedTable
          :spec="spec"
          :items="rows"
          :count="count"
          :navigation="nav"
          @update:navigation="v => (nav = v)"
          noData="Não existem registros para o filtro informado."
          @rowClicked="showDetailsDialog"
        />
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import { Redis } from '@/models'

const spec = [
  { t: '|Key', d: 'key', sortBy: false },
  { t: 'Type|', d: 'type', sortBy: false }
]

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    OPaginatedTable: require('oderon-vue/cpts/OPaginatedTable').default,
    DetailsDialog: require('./DetailsDialog').default
  },
  data() {
    return {
      isLoading: false,

      spec,

      selectedDb: 0,
      allDbs: [
        { value: 0, label: 'Queues' },
        { value: 1, label: 'Caches de relatórios' },
        { value: 2, label: 'Diagnósticos do Pipeline' },
        { value: 3, label: '(old) Caches do Watchdog-Worker' },
        { value: 4, label: 'Últimos HBs de cada módulo' },
        { value: 5, label: 'Tokens-Usuários do Gateman' },
        { value: 6, label: 'Infos dos servidores' },
        { value: 7, label: 'Vehicle-Datas de cada veículo' },
        { value: 8, label: 'Sequences compartilhadas' }
      ],

      count: null,
      nav: {
        offset: 0,
        limit: 20
      },
      rows: []
    }
  },
  watch: {
    nav() {
      this.reload()
    },
    selectedDb() {
      this.reloadFromStart()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    reloadFromStart() {
      this.nav.offset = 0
      this.reload()
    },

    async fetchData() {
      let { limit, offset } = this.nav,
        db = this.selectedDb
      let res = await Redis.findAll(db, { limit, offset })
      this.rows = res.rows
      this.count = res.count
    },

    async showDetailsDialog(row) {
      let res = await this.$refs.detailsDialog.open(this.selectedDb, row.key)
      if (res === 'DELETE') {
        this.$loading(() => this.deleteRow(row))
      }
    },

    async deleteRow(row) {
      let db = this.selectedDb,
        key = row.key
      await Redis.delete(db, key)
      await this.fetchData()
      this.$snack('Removido com sucesso')
    }
  }
}
</script>

<style></style>
